import { AxiosRequestConfig } from 'axios';

export const DEFAULT_CONFIG: AxiosRequestConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/default-config.ts